<div class="chart-container" [style]="style">
  <canvas
    baseChart
    [data]="pieChartData"
    [type]="pieChartType"
    [options]="pieChartOptions"
    [labels]="pieChartData?.labels"
    [plugins]="chartPlugins"
  >
  </canvas>
</div>
